// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VCRM6","toggle":"styles_toggle__3TBjl","preview":"styles_preview__3ZmpH"};